import React from 'react';
import { Box, Spinner } from '@chakra-ui/react';

const LoadingSpinner = () => (
  <Box display="flex" justifyContent="center" py={8}>
    <Spinner />
  </Box>
);

export default LoadingSpinner;
